import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useStore } from "../../app/stores/store";

import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import "./Operaciones_style.css";
import "./CuotasTabla.css"
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";

// Componente que no renderiza nada


export default observer(function CuotasTabla() {
  const { CuotasStore } = useStore();
  const { detailedCuotas, loadCuotasListDetailed } = CuotasStore;

  useEffect(() => {
    loadCuotasListDetailed();
  }, []);

  // Estado para la paginación
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 3; // Fijamos las filas por página a 3

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  function NoActionsComponent() {
    return null;
  }

  return (
    <div id="contenedor_busqueda_movimiento">
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <b>No.</b>
              </TableCell>
              <TableCell align="center">
                <b>Curso</b>
              </TableCell>
              <TableCell align="center">
                <b>Edición</b>
              </TableCell>
              <TableCell align="center">
                <b>Monto</b>
              </TableCell>
              <TableCell align="center">
                <b>Tipo de Cuenta</b>
              </TableCell>
              <TableCell align="center">
                <b>Tipo de Transacción</b>
              </TableCell>
              <TableCell align="center">
                <b>Fecha de Cobro Programado</b>
              </TableCell>
              <TableCell align="center">
                <b>Se aplica en inscripción</b>
              </TableCell>
              <TableCell align="center">
                <b>Proceso de carga aplicado</b>
              </TableCell>
              <TableCell align="center">
                <b>Fecha de Registro</b>
              </TableCell>
              <TableCell align="center">
                <b>Usuario</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {detailedCuotas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((activities) => {
              return (
                
                  <TableRow key={activities.id}>
                    <TableCell component="th" scope="row" align="center">{activities.id}</TableCell>
                    <TableCell align="center">{activities.curso}</TableCell>
                    <TableCell align="center">{activities.edicion}</TableCell>
                    <TableCell align="center">{activities.monto}</TableCell>
                    <TableCell align="center">{activities.cuenta}</TableCell>
                    <TableCell align="center">{activities.transaccion}</TableCell>
                    <TableCell align="center">{activities.fecha}</TableCell>
                    <TableCell align="center">{activities.aplicaInscripcion}</TableCell>
                    <TableCell align="center">{activities.procesoCargoAplicado}</TableCell>
                    <TableCell align="center">{activities.fechaRegistro}</TableCell>
                    <TableCell align="center">{activities.usuarioRegistra}</TableCell>
                  </TableRow>
                
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow>
            <TableCell colSpan={11}>
            <TablePagination
                component="div"
                count={detailedCuotas.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPageOptions={[3]} // Solo se permite un valor de 3
                />
            </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
});
